import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SPaymentRefundDetailsContentColumn = styled.div`
  ${setFlexDFFDC};
`;
